import React from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { MerchantMainInfo } from "./MerchantMainInfo"
import { MerchantContactDetails } from "./MerchantContactDetails"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { CreditCardsPaymentAside } from "./CreditCardsPaymentAside"
import { OpeningHoursAsideWrapper } from "./OpeningHours/OpenigHoursAsideWrapper"

export function MerchantFormContent() {
    return (
        <StandardForm>
            <StandardMainPanel>
                <MerchantMainInfo readonly />
            </StandardMainPanel>
            <LocalizedStrict id="create-or-edit-supplier-admin-merchant-contact-details-title" attrs={{ title: true }}>
                <StandardMainPanel variant="collapsible" title="Contact details">
                    <MerchantContactDetails />
                </StandardMainPanel>
            </LocalizedStrict>

            <LocalizedStrict
                id="create-or-edit-supplier-admin-merchant-credit-card-payments-title"
                attrs={{ title: true }}
            >
                <StandardSidePanel variant="collapsible" title="Credit card payments">
                    <CreditCardsPaymentAside />
                </StandardSidePanel>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-update-account-opening-hours-title" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Opening hours">
                    <OpeningHoursAsideWrapper />
                </StandardSidePanel>
            </LocalizedStrict>
        </StandardForm>
    )
}
